{
  "collapse": "접기",
  "expand": "펼치기"
}
